/**
 * Iter-104 — Local email-history persistence.
 *
 * Stores up to 30 unique emails per (user_id, channel) tuple in localStorage,
 * MRU-ordered. Used by the Weekly CRA dialog and the Email tab to surface a
 * <datalist> dropdown so the user doesn't have to retype recipients every time.
 *
 * Storage key shape: `baim:emailHistory:{user_id}:{channel}` → JSON array of strings.
 * Channel examples: "wkcra-to", "wkcra-cc", "email-to", "email-cc".
 */
const MAX_HISTORY = 30;

function _key(userId, channel) {
  return `baim:emailHistory:${userId || "anon"}:${channel}`;
}

export function getEmailHistory(userId, channel) {
  try {
    const raw = localStorage.getItem(_key(userId, channel));
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((s) => typeof s === "string" && s.includes("@")) : [];
  } catch {
    return [];
  }
}

export function rememberEmail(userId, channel, ...emails) {
  if (!emails || !emails.length) return;
  try {
    const cur = getEmailHistory(userId, channel);
    // Push new emails first (deduped, case-insensitive), keep MRU order.
    const seen = new Set();
    const merged = [];
    for (const raw of [...emails, ...cur]) {
      const e = (raw || "").trim();
      if (!e || !e.includes("@")) continue;
      const lc = e.toLowerCase();
      if (seen.has(lc)) continue;
      seen.add(lc);
      merged.push(e);
      if (merged.length >= MAX_HISTORY) break;
    }
    localStorage.setItem(_key(userId, channel), JSON.stringify(merged));
  } catch {
    // localStorage can throw in private mode; ignore — feature degrades gracefully.
  }
}
